<ul *ngIf="coreData.IsMobile" class="row g-0  justify-content-start" style="list-style: none; padding-left: 0px;">
    <li class="nav-item col-6 col-md-auto" [routerLinkActive]='["link-active"]'>
        <a class="nav-link text-start row align-items-center w-100" (click)="navigateToPrestation()">
            <mat-icon>directions_boat_filled</mat-icon>
            <div class="col-auto ms-2">Prestation</div>
        </a>
    </li>
    <li class="nav-item col-6 col-md-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
        <a class="nav-link text-start row align-items-center w-100" (click)="navigateTo(ENavigationRoute.InterventionDashboard)">
            <mat-icon>dashboard</mat-icon>
            <div class="col-auto ms-2">Dashboard</div>
        </a>
    </li>
    <li *ngIf="InterventionType !== EInterventionType.LAC" class="nav-item col-6 col-md-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
        <a class="nav-link text-start row align-items-center w-100" (click)="navigateTo(ENavigationRoute.DescriptionStation)">
            <mat-icon>list</mat-icon>
            <div class="col-auto ms-2">Description</div>
        </a>
    </li>
    <li *ngIf="InterventionType === EInterventionType.IBGN || InterventionType === EInterventionType.MPCE" class="nav-item col-6 col-md-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
        <a class="nav-link text-start row align-items-center w-100" (click)="navigateTo(ENavigationRoute.PlanPrelevement);">
            <mat-icon>map</mat-icon>
            <div class="col-auto ms-2">Plan </div>
        </a>
    </li>
    <li class="nav-item col-6 col-md-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
        <a class="nav-link text-start row align-items-center w-100" (click)="navigateTo(ENavigationRoute.Photo);">
            <mat-icon fontSet="material-icons-outlined">
                photo
            </mat-icon>
            <div class="col-auto ms-2">Photo</div>
        </a>
    </li>
    <li class="nav-item col-6 " [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
        <a class="nav-link text-start row align-items-center w-100" (click)="navigateTo(ENavigationRoute.InterventionList)">
            <mat-icon fontSet="material-icons-outlined">
                home
            </mat-icon>
            <div class="col-auto ms-2">Home</div>
        </a>
    </li>
</ul>

<ul *ngIf="!coreData.IsMobile" class="row g-0 mb-0" style="list-style: none; padding-left: 0px;">
    <li class="nav-item col-auto " [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
        <a class="clickable nav-link row align-items-center w-100" (click)="navigateTo(ENavigationRoute.InterventionList)">
            <div>
                <mat-icon fontSet="material-icons-outlined">
                    home
                </mat-icon>
            </div>
            <div class="">Home</div>
        </a>
    </li>
    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]'>
        <a class="clickable nav-link row align-items-center w-100" (click)="navigateToPrestation()">
            <div>
                <mat-icon>directions_boat_filled</mat-icon>
            </div>
            <div class="">Prestation</div>
        </a>
    </li>
    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
        <a class="clickable nav-link row align-items-center w-100" (click)="navigateTo(ENavigationRoute.InterventionDashboard)">
            <div>
                <mat-icon>dashboard</mat-icon>
            </div>
            <div class="">Dashboard</div>
        </a>
    </li>
    <li *ngIf="InterventionType !== EInterventionType.LAC" class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
        <a class="clickable nav-link row align-items-center w-100" (click)="navigateTo(ENavigationRoute.DescriptionStation)">
            <div>
                <mat-icon>list</mat-icon>
            </div>
            <div class="">Description</div>
        </a>
    </li>
    <li *ngIf="InterventionType === EInterventionType.IBGN || InterventionType === EInterventionType.MPCE" class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
        <a class="clickable nav-link row align-items-center w-100" (click)="navigateTo(ENavigationRoute.PlanPrelevement);">
            <div>
                <mat-icon>map</mat-icon>
            </div>
            <div class="">Plan </div>
        </a>
    </li>
    <li class="nav-item col-auto" [routerLinkActive]='["link-active"]' [routerLinkActiveOptions]='{ exact: true }'>
        <a class="clickable nav-link row align-items-center w-100" (click)="navigateTo(ENavigationRoute.Photo);">
            <div>
                <mat-icon fontSet="material-icons-outlined">
                    photo
                </mat-icon>
            </div>
            <div class="">Photo</div>
        </a>
    </li>

</ul>